import React, { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import TaxiAlertIcon from "@mui/icons-material/TaxiAlert";
import CancelCallModal from "../Structure/CancelCallModal";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

function ActiveCallsTable({ data, cancelCall, remakeCall }) {
  // 1) Data
  const [showModal, setshowModal] = useState(false);
  const [selectedData, setselectedData] = useState();
  const { t } = useTranslation();
  // 3) function

  return (
    <>
      <div className="table-container ">
        {/*Desktop Table */}
        <table className="hideBigTable">
          <thead>
            <tr>
              <th>{t("Ημ/νία&Ώρα")}</th>
              <th>{t("Κατάσταση")}</th>
              <th>{t("Destination")}</th>
              <th>{t("Customer")}</th>
              <th>{t("Driver")}</th>
              <th>{t("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <>
                <tr key={item.info.date} className="hover:bg-gray-300 ">
                  <td className="h-14">
                    <div className="bg-gray-200 h-full text-center rounded-md p-1 flex-row justify-center items-center">
                      {item.info.receivedDate == "" ? (
                        "-"
                      ) : (
                        <>
                          <span className="font-semibold flex-col">
                            {item.info.receivedDate.split("T")[1].split(".")[0]}
                          </span>
                          <br />
                          {item.info.receivedDate.split("T")[0]}
                        </>
                      )}
                    </div>
                  </td>
                  <td className="h-14">
                    <div className="bg-gray-200 text-center flex items-center justify-center rounded-md p-1 h-full">
                      {(item.info.callStatus == 10 ||
                        item.info.callStatus == 11) && (
                        <div className="flex items-center justify-center ">
                          <CheckCircleOutlineIcon className="text-green-500" />
                          <div className=" text-gray-500 text-base px-3">
                            {t("Βρέθηκε")}
                          </div>
                        </div>
                      )}
                      {(item.info.callStatus == 31 ||
                        item.info.callStatus == 31) && (
                        <div className="flex items-center justify-center">
                          <CancelIcon className="text-red-500" />
                          <div className=" text-gray-500 text-base px-3">
                            {t("Ακυρώθηκε")}
                          </div>
                        </div>
                      )}
                      {(item.info.callStatus == 0 ||
                        item.info.callStatus == 1) && (
                        <div className="flex items-center justify-center">
                          <PersonSearchIcon className="text-indigo-500" />
                          <div className=" text-gray-500 text-base px-3">
                            {t("Αναζήτηση")}
                          </div>
                        </div>
                      )}
                      {(item.info.callStatus == 20 ||
                        item.info.callStatus == 21) && (
                        <div className="flex items-center justify-center">
                          <TaxiAlertIcon className="text-gray-500" />
                          <div className=" text-gray-500 text-small px-3">
                            {t("Δεν_Βρέθηκε")}
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="h-14">
                    <div className="bg-gray-200 h-full text-center rounded-md p-1">
                      {item.info.destination}
                      {item.distance != undefined && " - " + item.distance}{" "}
                      <br />
                      {item.duration != undefined && (
                        <span className="bg-green-400 p-0.5">
                          {item.duration}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="h-14">
                    <div className="bg-gray-200 h-full text-center rounded-md p-1 flex justify-center items-center">
                      {item.info.customerName == "" ? (
                        "-"
                      ) : (
                        <>{item.info.customerName}</>
                      )}
                    </div>
                  </td>
                  <td className="h-14">
                    <div className="bg-gray-200 h-full text-center rounded-md p-1 flex items-center justify-center">
                      {item.info.driverId == "" ? (
                        "-"
                      ) : (
                        <>
                          {item.driverFirstName + " " + item.driverLastName}
                          <br />
                          {t("Κωδ.") +
                            " " +
                            item.info.driverId +
                            " - " +
                            t("Taxi") +
                            item.info.taxiNo +
                            " -  " +
                            t("Πινακίδα") +
                            item.taxiLicNo}
                        </>
                      )}
                    </div>
                  </td>
                  <td className="h-14">
                    <div className="bg-gray-200 h-full text-center rounded-md p-1 flex items-center justify-center">
                      {(item.info.callStatus == 31 ||
                        item.info.callStatus == 31) && (
                        <div className="flex items-center justify-center">
                          <div className=" text-gray-200 text-base px-3">-</div>
                        </div>
                      )}
                      {(item.info.callStatus == 10 ||
                        item.info.callStatus == 11) && (
                        <div className="flex items-center justify-center">
                          <div
                            onClick={async () => {
                              //console.log("ITEM : ", item);
                              await setselectedData(item);
                              setshowModal(true);
                            }}
                            className="text-base px-3 border border-red-500 rounded p-1 cursor-pointer hover:scale-105 flex items-center justify-center"
                          >
                            <div className=" bg-red-500 text-white h-5 w-5 rounded-full flex justify-center items-center mr-2">
                              <CloseIcon fontSize="small" />
                            </div>

                            <p className="font-semibold">{t("Ακύρωση")}</p>
                          </div>
                        </div>
                      )}
                      {(item.info.callStatus == 0 ||
                        item.info.callStatus == 1) && (
                        <div className="flex items-center">
                          <div className=" text-gray-500 text-base px-3">-</div>
                        </div>
                      )}
                      {(item.info.callStatus == 20 ||
                        item.info.callStatus == 21) && (
                        <div className="flex items-center justify-center">
                          <div
                            onClick={() => remakeCall(item)}
                            className="bg-gray-500 rounded text-white text-small px-3 cursor-pointer hover:scale-105"
                          >
                            {t("Επανάληψη")}
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
        {/* Mobile Phones Table */}
        <table className="showSmallTable">
          <tbody>
            {data.map((item) => (
              <>
                <tr
                  key={item.info.date}
                  className="rounded-md shadow shadow-gray-400"
                >
                  {(item.info.callStatus == 10 ||
                    item.info.callStatus == 11) && (
                    <div className="Primary_Main_Background Primary_Dark_Text text-end mt-3  rounded-t  p-1">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <CheckCircleOutlineIcon className="text-white" />
                          <div className=" text-white  text-base px-3">
                            {t("Βρέθηκε")}
                          </div>
                        </div>
                        <div
                          onClick={async () => {
                            //console.log("ITEM : ", item);
                            await setselectedData(item);
                            setshowModal(true);
                          }}
                          className="Primary_Light_Background rounded Primary_Dark_Text text-base px-3 cursor-pointer hover:scale-105 flex p-1 items-center"
                        >
                          <div className=" bg-red-500 text-white h-5 w-5 rounded-full flex justify-center items-center mr-2 ">
                            <CloseIcon fontSize="small" />
                          </div>
                          {t("Ακύρωση")}
                        </div>
                      </div>
                    </div>
                  )}
                  {(item.info.callStatus == 31 ||
                    item.info.callStatus == 31) && (
                    <div className="bg-gray-300 Primary_Dark_Text text-end mt-3  rounded-t  p-1">
                      <div className="flex items-center justify-start">
                        <CancelIcon className="text-red-500" />
                        <div className="  text-base px-3">
                          {" "}
                          {t("Ακυρώθηκε")}
                        </div>
                      </div>
                    </div>
                  )}
                  {(item.info.callStatus == 0 || item.info.callStatus == 1) && (
                    <div className="Primary_Light_Background Primary_Dark_Text text-end mt-3  rounded-t  p-1">
                      <div className="flex items-center justify-start">
                        <PersonSearchIcon className="text-indigo-500" />
                        <div className="  text-base px-3">
                          {" "}
                          {t("Αναζήτηση")}
                        </div>
                      </div>
                    </div>
                  )}
                  {(item.info.callStatus == 20 ||
                    item.info.callStatus == 21) && (
                    <div className="bg-gray-500 Primary_Dark_Text text-end mt-3  rounded-t  p-1">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center text-white">
                          <TaxiAlertIcon className=" text-white" />
                          <div className=" text-base px-3">
                            {t("Το_όχημα_δε_βρέθηκε")}
                          </div>
                        </div>
                        <div
                          onClick={() => remakeCall(item)}
                          className="Primary_Light_Background Primary_Dark_Text rounded text-white text-base px-3 cursor-pointer hover:scale-105"
                        >
                          {t("Επανάληψη")}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                    {item.info.receivedDate == "" ? (
                      "-"
                    ) : (
                      <>
                        {t("Ημ/νία&Ώρα") +
                          ": " +
                          item.info.receivedDate.split("T")[0]}
                        {" & " +
                          item.info.receivedDate.split("T")[1].split(".")[0]}
                      </>
                    )}
                  </div>

                  <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                    {t("Destination") + " : "} {item.info.destination}
                  </div>

                  {item.distance != undefined && (
                    <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                      {item.distance != undefined &&
                        t("Απόσταση-Χρόνος") + " : " + item.distance + " - "}
                      {item.duration != undefined && (
                        <span className="bg-green-400 p-0.5">
                          {item.duration}
                        </span>
                      )}
                    </div>
                  )}

                  <>
                    {(item.info.callStatus == 10 ||
                      item.info.callStatus == 11) && (
                      <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                        {t("Oδηγός")} {" : "}
                        {item.driverFirstName + " " + item.driverLastName}
                        {t("Κωδ.") +
                          " " +
                          item.info.driverId +
                          " - " +
                          t("Taxi") +
                          item.info.taxiNo +
                          " -  " +
                          t("Πινακίδα") +
                          item.taxiLicNo}
                      </div>
                    )}
                  </>

                  <div className="bg-gray-200  p-1 text-gray-500 text-base px-3">
                    {t("Πελάτης")} {" : "}
                    {item.info.customerName == "" ? (
                      "-"
                    ) : (
                      <>{item.info.customerName}</>
                    )}
                  </div>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <>
          <CancelCallModal
            showModal={showModal}
            setshowModal={setshowModal}
            cancelObject={selectedData}
            cancelCall={cancelCall}
          />
        </>
      )}
    </>
  );
}

export default ActiveCallsTable;
